<div class="main">
  <div class="logo">
    <img src="assets/general/logo.png" />
    <p>بنتو</p>
  </div>
  <div class="message-box">
    <p class="title">شماره همراه خود را وارد کنید</p>
    <p>یک کد جهت تایید برای شما پیامک خواهد شد.</p>
  </div>
  <div
    [ngClass]="
      phoneNumber && !hasError
        ? 'input-box active'
        : hasError
        ? 'input-box error'
        : 'input-box disable'
    "
  >
    <span class="input-focuse" *ngIf="!!isFocuse"> شماره همراه </span>
    <img
      class="phone-image"
      *ngIf="!isFocuse"
      src="assets/authentication/phone.svg"
    />
    <input
      type="tel"
      id="phoneInput"
      [(ngModel)]="phoneNumber"
      [placeholder]="isFocuse ? '' : '*شماره همراه'"
      (ngModelChange)="activate()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      maxlength="11"
    />
    <div class="icons">
      <img
        *ngIf="phoneNumber && phoneNumber.split.length > 1 && !hasError"
        src="assets/authentication/close.svg"
        (click)="clearInput()"
        alt=""
      />
      <img
        *ngIf="hasError && !isFocuse"
        src="assets/authentication/error.svg"
        alt=""
      />
    </div>
  </div>
  <p class="require-message" *ngIf="!hasError">*این فیلد الزامی است.</p>
  <div *ngIf="hasError" class="error require-message">{{ errorMessage }}</div>
  <!-- <p class="rules">
    با ثبت‌نام و ورود, با <span (click)="goTerms()">قوانین بنتو</span> موافقت
    می‌کنید.
  </p> -->
  <!-- <app-submit-button [title]="buttonTitle"></app-submit-button> -->
  <div
    class="resume-button"
    (click)="resumeClick()"
    [ngClass]="{ active: isActive }"
  >
    ادامه
  </div>
  <div class="or-dividar">
    <div></div>
    <span> یا </span>
  </div>
  <div
    class="google-login"
    [ngStyle]="{ top: top + 'px' }"
    (click)="googleAuth()"
  >
    <div>
      <span> ثبت‌نام با گوگل </span>
      <img class="google-image" src="assets/authentication/google.svg" />
    </div>
  </div>
  <!-- <app-loading *ngIf="showLoading"></app-loading> -->
  <app-loading-spinner
    [isDone]="isDone"
    *ngIf="showLoading"
  ></app-loading-spinner>
</div>
